import React, { Component } from 'react';
import SideMenuLeft from './SideMenuLeft';
import SideMenuRight from './SideMenuRight';

export default class SideMenuWrapper extends Component {
  render() {
    return (
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-2 hidden-md-down">
            <SideMenuLeft />
          </div>

          <div className="col-md-8 pl-4">{this.props.children}</div>

          <div className="col-md-2 hidden-md-down">
            <SideMenuRight />
          </div>
        </div>
      </div>
    );
  }
}
